import { Component, EventEmitter, Output, OnDestroy, Renderer2 } from '@angular/core';
import { DropdownSelectItemComponent } from './dropdown-select-item/dropdown-select-item.component';
import { height } from '../../animations/animations';

@Component({
    selector: 'dropdown-select-button',
    templateUrl: './dropdown-select-button.component.html',
    styleUrls: ['./dropdown-select-button.component.scss'],
    animations: [
        height('50ms')
    ],
    standalone: false
})
export class DropdownSelectButtonComponent implements OnDestroy {
    @Output()
    selectedValue: EventEmitter<any> = new EventEmitter();
    active: boolean = false;
    items: DropdownSelectItemComponent[] = [];
    public _mouseEventSub: Function;

    constructor(
        public _renderer: Renderer2
    ) { }

    ngOnDestroy() {
        if (this._mouseEventSub)
            this._mouseEventSub();
    }

    toggleMenu(event: MouseEvent | null): void {
        if (this._mouseEventSub) {
            this._mouseEventSub();
            this._mouseEventSub = null;
        }

        if (event != null) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();
        }
        this.active = !this.active;

        if (this.active) {
            this._mouseEventSub = this._renderer.listen('document', 'click', (event: MouseEvent) => {
    this.closeMenu();
});
        }
    }

    closeMenu() {
        this.active = false;
    }

    setSelected(item: DropdownSelectItemComponent): void {
        this.items.forEach(x => {
            x.selected = false;
        });

        item.selected = true;
        this.selectedValue.emit(item.value);
    }
}
